import {useEffect, useState} from "react";
import {findOrdersWithPagination} from "../api/eventGroupApiClient";

export const useOrders = (customerId, status, fromDate, toDate, page, pageSize, reloadTrigger) => {
    const [orders, setOrders] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const ordersWithPagination = findOrdersWithPagination(page, pageSize, customerId, status, fromDate, toDate, abortController.signal);

        ordersWithPagination
            .then(
                (data) => {
                    const orders = data.orders;
                    const pagination = data.pagination;

                    setOrders(orders)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [customerId, status, fromDate, toDate, page, pageSize, reloadTrigger]);

    return {orders : orders, pagination};
};